export default __webpack_public_path__ + "static/media/ICON8.bbfd2dfa.svg";